module.exports = __webpack_public_path__ + "img/temasek-foundation-logo.60639a84.svg";